import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormArray, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { filter, Observable, Subscription, take } from 'rxjs';
import { Patterns, SmoothScrollingService } from '@hrra/core';
import { ButtonTypeAttributeEnum, ButtonTypeEnum } from '@hrra/ui';
import { IconButtonTypeEnum } from '@hrra/ui';
import { changeWorkExperienceIsCurrent, downloadWorkExperienceAttachment, editJobseekerWorkExperience, setJobseekerWorkExperience, setSelectedCategories, setSelectedIndustries, updateEmploymentFormType, updateSeniorityLevelId, setSelectedSpecializations, updateEmploymentFormNewId, updateWorkScheduleId, addLocation, removeLocation, workExperienceFormSubmit } from 'src/app/root-store/jobseeker-store/jobseeker-profile/actions';
import { isFileUploading, selectedIndustries, selectedSpecializations, selectExtendedLocationCountLoading, selectFileName, selectIsEnableExtendedLocationAddButton, selectIsFileSizeValid, selectIsJobseekerProfileUpdating, selectIsWorkExperienceFormSubmitted, selectJobseekerId, selectJobseekerModerationLastChangeDate, selectJobseekerWorkExperience, selectMonthList, selectSelectedCategoryIds, selectSelectedEmploymentFormNew, selectSelectedFileText, selectSelectedIndustryIds, selectSelectedSeniorityLevel, selectSelectedSpecializationIds, selectSelectedWorkSchedule, selectWorkExperienceHasAttachment, selectWorkExperienceIsCurrent } from 'src/app/root-store/jobseeker-store/jobseeker-profile/selectors';
import { selectEmploymentNewFormsOptions, selectEmploymentTypeOptions, selectLocationFirstLevelId, selectLocationLastHiddenLevelCount, selectLocationLevelCount, selectLocationRequiredLevelCount, selectSeniorityLevelOptions, selectSystemConfigs, selectWorkScheduleOptions } from 'src/app/root-store/selectors';
import { AppState } from 'src/app/root-store/state';
import { SystemConfig } from 'src/app/shared/models/system-config-model';
import { SpecializationPickerService } from '../shared/services/specialization-picker.service';
import { JobseekerFileService } from '../shared/services/jobseeker-file.service';
import { FileUploadResultViewModel, JobseekerWorkExperienceModel } from '../shared/services/jobseeker.service';
import { JobseekerWorkExperienceViewModel, BasicOptionItem, EmploymentFormEnum, EmploymentFormTypeEnum } from '@hrra/common-models';
import { getJobseekerSpecializationList } from 'src/app/root-store/jobseeker-store/jobseeker-specialization/actions';
import { IndustryPickerService } from '../shared/services/industry-picker.service';
import { SeniorityLevelItem } from 'src/app/shared/models/seniority-level.model';
import { EmploymentFormTypeItem } from 'src/app/shared/models/employment-forms';
import { EmploymentContractTypeItem } from 'src/app/shared/models/employment-contract.model';
import { WorkScheduleItem } from 'src/app/shared/models/work-shchedule.model';
import { JobseekerExtendedLocationModel } from 'src/app/shared/models/jobseeker-location.model';
import { ExtendedLocationPath } from 'src/app/shared/models/location-picker-view-model';

@Component({
    selector: 'app-jobseeker-work-experience-edit',
    templateUrl: './redesign/jobseeker-work-experience-edit.component.html',
    styleUrls: ['./redesign/jobseeker-work-experience-edit.component.scss'],
    standalone: false
})
export class JobseekerWorkExperienceEditComponent implements OnInit {
  navigationSubs: Subscription;
  isCurrentSubscriber: Subscription;

  editForm: UntypedFormGroup

  @ViewChild('scrollContainer') scrollContainer: ElementRef

  jobseekerWorkExperience$: Observable<JobseekerWorkExperienceViewModel>;
  monthList$: Observable<BasicOptionItem[]>;
  selectedFile$: Observable<FileUploadResultViewModel>;
  isFileUploading$: Observable<boolean>;
  selectedSpecializationIds$: Observable<string[]>;
  selectedSpecializations$: Observable<any>;
  selectedCategoryIds$: Observable<number[]>;
  selectedCategories$: Observable<any>;
  isCurrent$: Observable<boolean>;
  isUpdating$: Observable<boolean>;
  employmentFormTypeEnum: any;
  selectedFileText$: Observable<string>;
  isFileSizeValid$: Observable<boolean>;
  systemConfigs$: Observable<SystemConfig>;
  moderationLastChangeDate$: Observable<Date>;
  selectHasAttachment$: Observable<boolean>;

  public selectedIndustryIds$: Observable<string[]>;
  public selectIndustries$: Observable<{head: string; subindustries: string[]}[]>;

  public seniorityLevelItems$: Observable<SeniorityLevelItem[]>;
  public selectedSeniorityLevelId$: Observable<string>;

  public jobseekerId$: Observable<number>;
  
  public employmentFormTypes$: Observable<EmploymentFormTypeItem[]>;

  public isFormSubmitted$: Observable<boolean>;
  public isAddLocationEnabled$: Observable<boolean>;
  public extendedLocationCount: Subscription;
  public workScheduleItems$: Observable<WorkScheduleItem[]>;
  public employmentFormTypeItems$: Observable<EmploymentContractTypeItem[]>;
  public selectedWorkSchedule$: Observable<string>;
  public selectedEmploymentFormNew$: Observable<string>;

  public title: string;
  public buttonType: any;
  public buttonAttributeType: any;
  public iconButtonType: any;
  public categoryButtonIsTouched: boolean;
  public specializationButtonIsTouched: boolean;

  public locationLevelCount$: Observable<number>;
  public locationRequiredLevelCount$: Observable<number>;
  public locationLastHiddenLevelCount$: Observable<number>;
  public locationFirstLevelId$: Observable<string>;

  public industryButtonIsTouched: boolean;

  constructor(private fb: UntypedFormBuilder, 
              private store: Store<AppState>, @Inject(MAT_DIALOG_DATA) public data, 
              private specializationPickerService: SpecializationPickerService, 
              public dialogRef: MatDialogRef<JobseekerWorkExperienceEditComponent>,
              private fileService: JobseekerFileService,
              private industryPickerService: IndustryPickerService,
              private smoothScrollService: SmoothScrollingService,
              private router: Router) {
    this.iconButtonType = IconButtonTypeEnum;
    this.buttonType = ButtonTypeEnum;
    this.buttonAttributeType = ButtonTypeAttributeEnum;
    this.employmentFormTypeEnum = EmploymentFormTypeEnum;

    this.editForm = this.fb.group({
      positionTitle: new UntypedFormControl(null, [Validators.required]),
      employer: new UntypedFormControl(null, [Validators.required]),
      dateFromMonth: new UntypedFormControl(null),
      dateFromYear: new UntypedFormControl(null, [Validators.required, Validators.pattern(Patterns.year)]),
      dateToMonth: new UntypedFormControl(null),
      dateToYear: new UntypedFormControl(null, [Validators.pattern(Patterns.year)]),
      isCurrent: new UntypedFormControl(false),
      description: new UntypedFormControl(null),
      extendedLocationPathList: new UntypedFormArray(
        [new UntypedFormControl(null)],
        [Validators.required]
      ),
      employmentFormTypeId: new UntypedFormControl(EmploymentFormTypeEnum.OnSite),
    }, { validators: [this.customValidator,  this.extendedLocationValidator, this.extendedLocationsRequired]},)

    this.navigationSubs = this.router.events.subscribe(e => {
      if(e instanceof NavigationEnd){
        this.dialogRef.close();
      }
    });
   }

   public industryPicker(industries: string[]) {
    this.industryButtonIsTouched = true
    this.industryPickerService.pickIndustry((industryIds) => {
      this.store.dispatch(setSelectedIndustries({ payload: industryIds }));
    }, industries);
  }

  handleEmploymentTypeChange(): void {
    this.editForm.get('employmentFormTypeId')?.valueChanges.subscribe((value) => {
      const extendedLocations = this.editForm.get('extendedLocationPathList') as UntypedFormArray;
  
      if (value === EmploymentFormTypeEnum.WorkFromHome) {
        extendedLocations.clear();
        extendedLocations.push(new UntypedFormControl({ value: null, disabled: true }));
        extendedLocations.disable(); 
      } else {
        if (extendedLocations.disabled) {
          extendedLocations.enable();
        }
  
        if (extendedLocations.length === 0) {
          extendedLocations.push(new UntypedFormControl(null));
        }
      }
    })}

  extendedLocationValidator(group: UntypedFormGroup): ValidationErrors | null {
    if (group) {
      const extendendLocations = group.controls['extendedLocationPathList'].value;
      const extendedLocationSet = new Set<string>();
      const employmentTypeId = group.controls['employmentFormTypeId'].value
      for (let i = 0; i < extendendLocations.length; i++) {
        if (extendendLocations[i] == null) continue;
        const locationKey = extendendLocations[i].locations
          .map((c) => c.locationId)
          .join(',');
        if (extendedLocationSet.has(locationKey) && employmentTypeId !== EmploymentFormTypeEnum.WorkFromHome) {
          return { SameExtendedLocation: true };
        }
        extendedLocationSet.add(locationKey);
      }
    }
    return null;
  }

  extendedLocationsRequired(group: UntypedFormGroup): ValidationErrors | null {
    if (group) {
      const controls = group.controls['extendedLocationPathList']['controls'];
      const employmentTypeId = group.controls['employmentFormTypeId'].value
      let hasValidExtendedLocation = false;
      for (let i = 0; i < controls.length; i++) {
        const control = controls[i];
        if (
          (control.touched || control.value != null) &&
          control.errors == null && employmentTypeId !== EmploymentFormTypeEnum.WorkFromHome
        ) {
          hasValidExtendedLocation = true;
          break;
        }
      }
      if (!hasValidExtendedLocation && employmentTypeId !== EmploymentFormTypeEnum.WorkFromHome) {
        return { ExtendedLocationsRequired: true };
      }
    }
    return null;
  }

  get locationControl() {
    return this.editForm.get('extendedLocationPathList') as FormArray;
  }

  customValidator(group : UntypedFormGroup) : {[s:string ]: boolean} {
    if (group) {
      let dateToYear = (group.controls['dateToYear'].value == null || group.controls['dateToYear'].value == '') ? null : +group.controls['dateToYear'].value;
      let dateToMonth = group.controls['dateToMonth'].value;
      let dateFromYear = +group.controls['dateFromYear'].value;
      let dateFromMonth = group.controls['dateFromMonth'].value;
      let isCurrent = group.controls['isCurrent'].value;

      dateFromMonth = dateFromMonth || 1;
      dateToMonth = dateToMonth || 12;

      var isDateValid = isCurrent || (dateToYear == null || (dateFromYear < dateToYear || (dateToYear == dateFromYear && dateFromMonth <= dateToMonth)));

      let customValidations:  {[s:string ]: boolean} = {};

      if(!isDateValid) {
          customValidations['date'] = true;
      }

      if(!isCurrent && dateToYear == null) {
          customValidations['RequiredYear'] = true;
      }

      return customValidations;
    }
  }

  ngOnInit(): void {
    this.title = this.data.title;

    this.extendedLocationCount = this.store
    .pipe(
      select(selectExtendedLocationCountLoading),
      filter((c) => !c.loading),
      take(1)
    )
    .subscribe((c) => {
      const extendedLocationsArray = this.editForm
        .get('extendedLocationPathList') as FormArray;
      this.editForm
        .get('extendedLocationPathList')
        .setValidators(Validators.maxLength(c.maxExperienceLocationCount));
      if (extendedLocationsArray.length > 0) {
        extendedLocationsArray.removeAt(0);
      }
      for (let i = 0; i < c.count; i++) {
        extendedLocationsArray.push(new UntypedFormControl(null));
      }
    });

    this.monthList$ = this.store.pipe(select(selectMonthList));
    this.moderationLastChangeDate$ = this.store.pipe(select(selectJobseekerModerationLastChangeDate));
    this.jobseekerWorkExperience$ = this.store.pipe(select(selectJobseekerWorkExperience));
    this.selectHasAttachment$ = this.store.pipe(select(selectWorkExperienceHasAttachment));
    
    this.selectedFile$ = this.store.pipe(select(selectFileName));
    this.isFileUploading$ = this.store.pipe(select(isFileUploading));
    this.selectedSpecializationIds$ = this.store.pipe(select(selectSelectedSpecializationIds));
    this.selectedSpecializations$ = this.store.pipe(select(selectedSpecializations));
    this.selectedCategoryIds$ = this.store.pipe(select(selectSelectedCategoryIds));
    this.selectIndustries$ = this.store.pipe(select(selectedIndustries));
    this.selectedIndustryIds$ = this.store.pipe(select(selectSelectedIndustryIds));
    this.isCurrent$ = this.store.pipe(select(selectWorkExperienceIsCurrent));
    this.isUpdating$ = this.store.pipe(select(selectIsJobseekerProfileUpdating));
    this.selectedFileText$ = this.store.pipe(select(selectSelectedFileText));
    this.isFileSizeValid$ = this.store.pipe(select(selectIsFileSizeValid));
    this.systemConfigs$ = this.store.pipe(select(selectSystemConfigs));
    this.isAddLocationEnabled$ = this.store.pipe(select(selectIsEnableExtendedLocationAddButton));
    this.isFormSubmitted$ = this.store.pipe(select(selectIsWorkExperienceFormSubmitted));
    this.jobseekerId$ = this.store.select(selectJobseekerId);
    

    this.locationLevelCount$ = this.store.pipe(select(selectLocationLevelCount));
    this.locationRequiredLevelCount$ = this.store.pipe(select(selectLocationRequiredLevelCount));
    this.locationLastHiddenLevelCount$ = this.store.pipe(select(selectLocationLastHiddenLevelCount));
    this.locationFirstLevelId$ = this.store.pipe(select(selectLocationFirstLevelId));

    this.seniorityLevelItems$ = this.store.pipe(select(selectSeniorityLevelOptions));
    this.selectedSeniorityLevelId$ = this.store.pipe(select(selectSelectedSeniorityLevel));
    this.employmentFormTypes$ = this.store.pipe(select(selectEmploymentTypeOptions));
    this.employmentFormTypeItems$ = this.store.pipe(select(selectEmploymentNewFormsOptions));
    this.workScheduleItems$ = this.store.pipe(select(selectWorkScheduleOptions));
    this.selectedWorkSchedule$ = this.store.pipe(select(selectSelectedWorkSchedule));
    this.selectedEmploymentFormNew$ = this.store.pipe(select(selectSelectedEmploymentFormNew));

    this.handleEmploymentTypeChange();

    // the end date is disabled while "currently work here" is checked
    this.isCurrentSubscriber = this.isCurrent$.subscribe(isCurrent => {
      for (const name of ['dateToMonth', 'dateToYear']) {
        const control = this.editForm.get(name);
        isCurrent ? control.disable({ emitEvent: false }) : control.enable({ emitEvent: false });
      }
    });
    
    setTimeout(() => {
      this.store.dispatch(setJobseekerWorkExperience({payload: this.data.workExperience}));
    }, 0);
  }

  onFileSelect(file: File, fileLimit: number){
    this.fileService.uploadFile(file, fileLimit);
  }

  onSelectSeniorityLevel(event) {
    this.store.dispatch(
      updateSeniorityLevelId({ payload: { seniorityLevelId: event.value } })
    );
  }

  onSelectWorkSchedule(event) {
    this.store.dispatch(
      updateWorkScheduleId({ payload: { workScheduleId: event.value } })
    );
  }

  onSelectEmploymentFormNew(event) {
    this.store.dispatch(
      updateEmploymentFormNewId({ payload: { employmentFormNewId: event.value } })
    );
  }

  updateEmploymentFormType(employmentTypeId: number) {
    this.store.dispatch(
      updateEmploymentFormType({ payload: { employmentTypeId } })
    );
  }

  downloadAttachment(experienceId: string){
    this.store.dispatch(downloadWorkExperienceAttachment({payload: {experienceId: experienceId}}));
  }

  removeLocation(index: number) {
    const extendedLocations = this.editForm.get('extendedLocationPathList') as FormArray;
    extendedLocations.removeAt(index);
    this.store.dispatch(removeLocation({ payload: { index } }));
  }

  resetLocation(index: number) {
    const extendedLocations = this.editForm.get(
      'extendedLocationPathList'
    ) as FormArray;
    extendedLocations.controls[index].reset();
  }

  addNewLocation() {
    const extendedLocations = this.editForm.get(
      'extendedLocationPathList'
    ) as FormArray;
    extendedLocations.push(new UntypedFormControl(null));
    this.store.dispatch(addLocation());
  }

  onSave(filename: string, categories: number[], industries: string[], specializations: string[], seniorityLevel: string, employmentFormId: string, workScheduleId: string, isFileSizeValid: boolean, jobseekerId: number, moderationLastChangeDate: Date){
    
    this.store.dispatch(workExperienceFormSubmit({ payload: true }));

    if(this.editForm.invalid || specializations?.length === 0 || industries?.length === 0 || !isFileSizeValid || !seniorityLevel || !workScheduleId || !employmentFormId){
      this.smoothScrollService.scrollToFirstInvalidControl(this.scrollContainer, 'input.ng-invalid, .has-error')
    }
    
    if(this.editForm.valid && specializations?.length > 0 && industries.length > 0 && isFileSizeValid && seniorityLevel && workScheduleId && employmentFormId){

      const value = this.editForm.value;
      const extendedLocationsList: JobseekerExtendedLocationModel[] =
      
      value.extendedLocationPathList?.filter((e) => e != null)
        .map((extendedLocationPath: ExtendedLocationPath, index: number) => {
          const locations = extendedLocationPath.locations;
          const firstHiddenLocationIdIndex = locations.findIndex(
            (c) => c.isHidden == true
          );
          let lastLocationIdIndex = locations.length;

          for (let i = locations.length - 1; i >= 0; i--) {
            if (
              locations[i].locationId !== '' &&
              locations[i].locationId !== undefined
            ) {
              lastLocationIdIndex = i;
              break;
            }
          }

          const jobseekerExtendedLocation = <
            JobseekerExtendedLocationModel
          >{
            locationId: locations[lastLocationIdIndex].locationId,
            lastVisibleLocationId:
              firstHiddenLocationIdIndex === -1
                ? null
                : locations[firstHiddenLocationIdIndex - 1].locationId,
            jobseekerId: 0,
            jobseekerExtendedLocationId: 0,
          };

          return jobseekerExtendedLocation;
        });

      let updateData = <JobseekerWorkExperienceModel>{
        jobseekerWorkExperienceId: this.data.workExperience?.experienceId,
        experienceId: this.data.workExperience?.jobseekerWorkExperienceId,
        dateFromMonth: value.dateFromMonth,
        dateFromYear: value.dateFromYear,
        // disabled while the jobseeker still works here, so missing from the form value
        dateToMonth: value.dateToMonth ?? null,
        dateToYear: value.dateToYear ?? null,
        isCurrent: value.isCurrent,
        employer: value.employer,
        positionTitle: value.positionTitle,
        description: value.description,
        occupationCategories: categories,
        specializations: specializations,
        industries: industries,
        extendedLocations: extendedLocationsList,
        seniorityLevelId: seniorityLevel,
        employmentTypeId: value.employmentFormTypeId,
        workScheduleId: workScheduleId,
        employmentFormId: employmentFormId,
        fileName: filename,
        objectId: this.data.workExperience?.objectId
      }

      this.store.dispatch(editJobseekerWorkExperience({payload:{jobseekerWorkExperienceModel: updateData , moderationLastChangeDate: moderationLastChangeDate}}));
    }
  }

  onCurrentExperience(isCurrent){
    if(!isCurrent){
      this.editForm.get('dateToMonth').reset();
      this.editForm.get('dateToYear').reset();
    }
    this.store.dispatch(changeWorkExperienceIsCurrent());
  }

  public categoryPicker(categories: number[]) {
    this.categoryButtonIsTouched = true;

    this.specializationPickerService.pickCategory(categoryIds => {
      this.store.dispatch(setSelectedCategories({payload: categoryIds}));
    },
      categories
    );
  }

  public specializationPicker(specializations: string[]) {
    this.specializationButtonIsTouched = true;

    this.specializationPickerService.pickSpecialization(specializationIds => {
      this.store.dispatch(setSelectedSpecializations({payload: specializationIds}));
    },
    specializations
    );
  }

  ngOnDestroy() {
    this.navigationSubs.unsubscribe();
    this.extendedLocationCount.unsubscribe();
    this.isCurrentSubscriber.unsubscribe();
  }
}
